import { render } from "./LoadPrices.vue?vue&type=template&id=4b6289ce"
import script from "./LoadPrices.vue?vue&type=script&lang=js"
export * from "./LoadPrices.vue?vue&type=script&lang=js"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/ParrillaPrecios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__